<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from '../../../../services/i18n';
	import { gen2Request } from '../../../../services/gen_2_http_reqs';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	//Stores
		//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	//Design system components
	import { Button, Input, Text, toast } from '@Shelly/shelly-design-system';

	$: settingsStore = getDeviceSettings(id);
	export let device;

	let id = real_id(device.id);

	let settings = $settingsStore;

	let maxtimeClose = $settingsStore[`cover:${device.channel}`].maxtime_close;
	let cacheClose = maxtimeClose;
	let maxtimeOpen = $settingsStore[`cover:${device.channel}`].maxtime_open;
	let cacheOpen = maxtimeOpen;
	let loading = false;

	const min = 0.1;
	const max = 300;

	$: errorMaxtimeOpen =
		maxtimeOpen && (+maxtimeOpen < min || +maxtimeOpen > max)
			? $format('generic_out_of_range', {
					default: `Value out of range`,
				})
			: '';

	$: errorMaxtimeClose =
		maxtimeClose && (+maxtimeClose < min || +maxtimeClose > max)
			? $format('generic_out_of_range', {
					default: `Value out of range`,
				})
			: '';

	const validate = (value) => {
		if (value > max) {
			value = max;
		}
		if (value < min) {
			value = min;
		}
		return value;
	};

	const setMovementLimit = async () => {
		if (cacheClose === maxtimeClose && cacheOpen === maxtimeOpen) return;
		loading = true;
		maxtimeClose = validate(maxtimeClose);
		maxtimeOpen = validate(maxtimeOpen);

		const params = {
			id: device.channel,
			config: {
				maxtime_open: maxtimeOpen,
				maxtime_close: maxtimeClose,
			},
		};

		const res: SettingRequest = await gen2Request(device, `Cover.SetConfig`, params);

		if (res.isok) {
			settings[`cover:${device.channel}`].maxtime_open = maxtimeOpen;
			settings[`cover:${device.channel}`].maxtime_close = maxtimeClose;
			devices_settings.update_devices_settings(id, settings);
			toast.open({
				type: 'success',
				title: $format('setting_scc_saved_toast'),
			});
			cacheClose = maxtimeClose;
			cacheOpen = maxtimeOpen;
		} else {
			toast.open({ type: 'danger', title: $format('error_global') });
			maxtimeClose = cacheClose;
			maxtimeOpen = cacheOpen;
		}
		loading = false;
	};
</script>

<Text styleType="body-small" class="mb-s">
	{$format('movement_limit_open_description', {
		values: { value: maxtimeOpen, min: min, max: max },
		default:
			'Limit the time for moving in a direction in seconds. Values must be from ${min} to ${max}. Note: Setting this to low value may affect calibration.',
	})}
</Text>
<Text styleType="body-small" class="mb-s">
	{$format('option_on_opening')}
</Text>
<Input
	class="mb-s"
	size="m"
	bind:value={maxtimeOpen}
	type={'number'}
	{min}
	{max}
	error={errorMaxtimeOpen}
	step={1}
	on:enter={() => {
		maxtimeOpen = validate(maxtimeOpen);
	}}
	on:enter={setMovementLimit}
	id="input-10cuhx1"
	aria-label={$format('option_on_opening', { default: 'On opening' })}
/>
<Text styleType="body-small" class="mb-s">
	{$format('option_on_closing')}
</Text>
<Input
	class="mb-s"
	size="m"
	bind:value={maxtimeClose}
	type={'number'}
	{min}
	{max}
	error={errorMaxtimeClose}
	step={1}
	on:enter={() => {
		maxtimeClose = validate(maxtimeClose);
	}}
	on:enter={setMovementLimit}
	id="input-2a3acn6"
	aria-label={$format('option_on_closing', { default: 'On closing' })}
/>
<Button class="mt-s" {loading} size="m" width="full" on:click={setMovementLimit}
	>{$format('button_save')}</Button
>
